(function($) {

	'use strict';

	var init = function() {
		initHeaderNav();
	}

	var initHeaderNav = function() {
		$('#hamburger').click(function(){
      console.log('yolo');
      var $this = $(this);
      $this.toggleClass('active');
      $('#main-header, .main-nav').toggleClass('active');
    });
	}

	$(document).ready(function() {
		init();
	});

})(jQuery);
